/**
 * Array Utils
 */

import { isEqual, isEqualWith, isObject, memoize, transform } from 'lodash';

export const defaultList = [];

export function rotateArray<K>(array: K[], count: number): K[] {
  /* tslint:disable:no-bitwise */
  const push = Array.prototype.push;
  const splice = Array.prototype.splice;
  const len = array.length >>> 0; // convert to uint

  count = count >> 0; // convert to int
  count = ((count % len) + len) % len;

  // use splice.call() instead of this.splice() to make function generic
  push.apply(array, splice.call(array, 0, count));
  return array;
}

export function objectIsArray(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

const diffOnObjects = memoize((object, base) => isObject(object) && isObject(base));

function diffCustomizer(object, base) {
  if (diffOnObjects(object, base)) {
    return isEqual(object, base);
  } else {
    return String(object) === String(base);
  }
}

export const diff = (object, base): any =>
  transform(object, (result, value, key) => {
    if (base && (key in base)) {
      if (!isEqualWith(value, base[key], diffCustomizer)) {
        result[key] = diffOnObjects(value, base[key]) ?
          diff(value, base[key])
          : value;
      }
    } else {
      result[key] = value;
    }
  });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/array.ts